import { cn } from "@quortex/front-common"
import type { FC, PropsWithChildren } from "react"

interface Props extends PropsWithChildren {
  fitContent?: boolean
}

const PanelTD: FC<Props> = ({ children, fitContent }) => (
  <td className="p-0">
    <div
      className={cn(
        "radius-xs flex min-h-[5.5rem] max-w-[22rem] items-center border border-grey-400 bg-white p-sm",
        fitContent && "min-w-fit"
      )}
    >
      <div className="w-full">{children}</div>
    </div>
  </td>
)

export default PanelTD
